import React from 'react';

const Badge = ({ 
  children, 
  variant = 'primary', 
  className = '' 
}) => {
  const baseStyles = "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold";
  
  const variants = {
    primary: "bg-primary-100 text-primary-800",
    success: "bg-green-100 text-semantic-success",
    warning: "bg-yellow-100 text-semantic-warning",
    danger: "bg-red-100 text-semantic-danger",
    neutral: "bg-gray-100 text-gray-800",
  };

  return (
    <span className={`${baseStyles} ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
